import { create } from 'zustand';

import type { PaymentErrorCode } from '@models/paymentErrorCodes';

type PaymentErrorsState = {
  paginatedErrors: PaymentErrorCode[];
  allErrors: PaymentErrorCode[];
  setPaginatedErrors: (errors: PaymentErrorCode[]) => void;
  setAllErrors: (errors: PaymentErrorCode[]) => void;
  resetPaginatedErrors: () => void;
  resetAllErrors: () => void;
};

export const useAllPaymentsErrorCodesStorage = create<PaymentErrorsState>((set) => ({
  paginatedErrors: [],
  allErrors: [],
  setPaginatedErrors: (newErrors) =>
    set((state) => ({
      paginatedErrors: [...state.paginatedErrors, ...newErrors],
    })),
  setAllErrors: (newErrors) => set({ allErrors: newErrors }),
  resetPaginatedErrors: () => set({ paginatedErrors: [] }),
  resetAllErrors: () => set({ allErrors: [] }),
}));

export const usePaginatedPaymentsErrorCodesStore = () =>
  useAllPaymentsErrorCodesStorage((state) => state.paginatedErrors);

export const useSetPaginatedPaymentsErrorCodesStore = () =>
  useAllPaymentsErrorCodesStorage((state) => state.setPaginatedErrors);

export const useResetPaginatedPaymentsErrorCodesStore = () =>
  useAllPaymentsErrorCodesStorage((state) => state.resetPaginatedErrors);

export const useAllPaymentsErrorCodesStore = () =>
  useAllPaymentsErrorCodesStorage((state) => state.allErrors);

export const useSetAllPaymentsErrorCodesStore = () =>
  useAllPaymentsErrorCodesStorage((state) => state.setAllErrors);

export const useResetAllPaymentsErrorCodesStore = () =>
  useAllPaymentsErrorCodesStorage((state) => state.resetAllErrors);
